import { OnboardingEvents, trackTagManagerEvent } from 'firebase-client';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Button, Typography } from 'ui';

import { autoDownloadFile } from '~/contract/helpers/autoDownloadFile';
import { useCreateContract } from '~/contract/hooks';
import { StepTitle } from '~/ui';

export const ContractDownloadStep = () => {
  const { t } = useTranslation('createContractWizard');
  const { onCompletion, contractData } = useCreateContract();

  const { contractNumber, signedContract } = contractData;
  return (
    <Box flex={1} display="flex" flexDirection="column" justifyContent="space-between">
      <Box>
        <Box mb={2}>
          <StepTitle>{t('download.title')}</StepTitle>
        </Box>

        <Trans
          i18nKey="createContractWizard:download.info"
          values={{
            contractNumber,
          }}
          components={[
            <Typography display="inline" />,
            <Typography fontWeight="bold" component="span" />,
            <Typography my={2} />,
          ]}
        />
      </Box>

      <Box display="flex" flexDirection="column" gap={2}>
        <Button size="lg" fullWidth onClick={onCompletion} data-testid="continue-button" color="gradient">
          {t('download.continue')}
        </Button>

        <Button
          size="lg"
          color="lightGrey"
          fullWidth
          onClick={() => {
            trackTagManagerEvent(OnboardingEvents.contractDownload);
            autoDownloadFile(signedContract, `${contractNumber}_signed_contract.pdf`);
          }}
        >
          {t('download.download')}
        </Button>
      </Box>
    </Box>
  );
};
